import { useCallback, useMemo } from "react";

import { ON_SUCCESS_CALLBACK_TYPE } from "@payment-ui/components/tick-screen/constants";
import { getTickScreenTransitionLottieUrl } from "@payment-ui/components/tick-screen/helpers";

interface UseTransitionSuccessCallbackArgs {
    isSwiggyBlackApplicable?: boolean;
    isSwiggyBlackOtpAnimationApplicable?: boolean;
    isPopCart?: boolean;
    isBoltCartM3?: boolean;
    isAffordableCartM2?: boolean;
    isToingFlow?: boolean;
    isGiftingCart?: boolean;
    isMroFlow?: boolean;
    onShowBottomStrip: () => void;
}

/**
 * Resolves post-success callback type from tick-screen lottie selection and
 * exposes the handler that advances MRO UI (footer strip) when that type wins.
 */
export const useTransitionSuccessCallback = ({
    isSwiggyBlackApplicable,
    isSwiggyBlackOtpAnimationApplicable,
    isPopCart,
    isBoltCartM3,
    isAffordableCartM2,
    isGiftingCart,
    isMroFlow,
    onShowBottomStrip,
}: UseTransitionSuccessCallbackArgs) => {
    const onSuccessCallbackType = useMemo(
        () =>
            getTickScreenTransitionLottieUrl({
                isSwiggyBlackApplicable,
                isSwiggyBlackOtpAnimationApplicable,
                isPopCart,
                isBoltCartM3,
                isAffordableCartM2,
                isGiftingCart,
                isMroFlow,
            }).onSuccessCallbackType,
        [
            isSwiggyBlackApplicable,
            isSwiggyBlackOtpAnimationApplicable,
            isPopCart,
            isBoltCartM3,
            isAffordableCartM2,
            isGiftingCart,
            isMroFlow,
        ],
    );

    const onSuccessState = useCallback(() => {
        switch (onSuccessCallbackType) {
            case ON_SUCCESS_CALLBACK_TYPE.MRO:
                onShowBottomStrip();
                break;
            case ON_SUCCESS_CALLBACK_TYPE.INVALID:
            default:
                break;
        }
    }, [onSuccessCallbackType, onShowBottomStrip]);

    return {
        onSuccessCallbackType,
        onSuccessState,
    };
};
